import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class PageSlug extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Slug",
    component: inspectorTools.SIMPLE_INPUT,
    descriptionMessage: "Location of your page. ex: your-site.com/about-us",
  };

  static defaultValue = "";
}
